import { render, staticRenderFns } from "./ControlGlob.vue?vue&type=template&id=4d730bba&"
import script from "./ControlGlob.vue?vue&type=script&lang=js&"
export * from "./ControlGlob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports